// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Jotai from "jotai";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as LocalStorage from "common/src/LocalStorage.bs.js";

var useSkinsKey = "tb-use-skins";

var showNamesKey = "tb-show-names";

var showItemSelectionKey = "tb-item-selection";

var disableTooltipsKey = "tb-disable-tooltips";

var compactModeKey = "tb-compact-mode";

var useSkins = Jotai.atom(true);

var showNames = Jotai.atom(true);

var showItemSelection = Jotai.atom(true);

var disableTooltips = Jotai.atom(false);

var compactMode = Jotai.atom(false);

function useInit(param) {
  var match = Jotai.useAtom(useSkins);
  var setUseSkins = match[1];
  var match$1 = Jotai.useAtom(showNames);
  var setShowNames = match$1[1];
  var match$2 = Jotai.useAtom(showItemSelection);
  var setShowItemSelection = match$2[1];
  var match$3 = Jotai.useAtom(disableTooltips);
  var setDisableTooltips = match$3[1];
  var disableTooltips$1 = match$3[0];
  var match$4 = Jotai.useAtom(compactMode);
  var compactMode$1 = match$4[0];
  React.useEffect((function () {
          Curry._1(setUseSkins, Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(LocalStorage.get(useSkinsKey)), true, (function (us) {
                      return us === "true";
                    })));
          Curry._1(setShowNames, Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(LocalStorage.get(showNamesKey)), true, (function (us) {
                      return us === "true";
                    })));
          Curry._1(setShowItemSelection, Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(LocalStorage.get(showItemSelectionKey)), true, (function (us) {
                      return us === "true";
                    })));
          Curry._1(setDisableTooltips, Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(LocalStorage.get(disableTooltipsKey)), false, (function (us) {
                      return us === "true";
                    })));
          
        }), []);
  React.useEffect((function () {
          LocalStorage.set(disableTooltipsKey, Belt_Option.getExn(JSON.stringify(disableTooltips$1)));
          
        }), [disableTooltips$1]);
  React.useEffect((function () {
          LocalStorage.set(compactModeKey, Belt_Option.getExn(JSON.stringify(compactMode$1)));
          
        }), [compactMode$1]);
  
}

export {
  useSkinsKey ,
  showNamesKey ,
  showItemSelectionKey ,
  disableTooltipsKey ,
  compactModeKey ,
  useSkins ,
  showNames ,
  showItemSelection ,
  disableTooltips ,
  compactMode ,
  useInit ,
  
}
/* useSkins Not a pure module */
